import * as R from 'ramda';
import angular from 'angular';
import * as Highcharts from 'highcharts';

require('highcharts');


export default function ProductController(
  $q,
  $rootScope,
  $scope,
  alerts,
  brandColors,
  confirmDialog,
  copy,
  loaderService,
  ssDialogService,
  userService,
  orgDataService,
  vmDataService,
  vmSharedModelService,
  reportsDataService,
  viewContactsDialog,
  editProductDialog,
  confirmBeginRiskAssessmentDialog,
  confirmControlsReviewDialog,
  selectRiskControlsForReviewDialog,
  performRiskAssessmentDialog
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.filters = vmSharedModelService.filters;
  vm.product.detailedDataIsLoaded = false;
  vm.productViewType = 'graph';
  vm.currentControlsReviewTask = null;

  vm.handleExpandProduct = _handleExpandProduct;
  vm.handleShowContacts = _handleShowContacts;
  vm.handleEditProduct = _handleEditProduct;
  vm.handlePerformRiskAssessment = _handlePerformRiskAssessment;
  vm.handlePerformControlsReview = _handlePerformControlsReview;
  vm.handleRunDetailReport = _handleRunDetailReport;
  vm.handleDeleteProduct = _handleDeleteProduct;
  vm.handleShowGraphView = _handleShowGraphView;
  vm.handleShowListView = _handleShowListView;

  _activate();

  _initEventListeners();

  /** *************************************************************
   * Event Handlers
   */

  function _handleExpandProduct($event) {
    if (vm.canExpand) {
      if (vm.product.detailedDataIsLoaded) {
        vm.product.isExpanded = !vm.product.isExpanded;
        return true;
      }
      loaderService.showViewLoader = true;
      _loadProductDetails($event).then(() => {
        loaderService.showViewLoader = false;
        vm.product.isExpanded = !vm.product.isExpanded;
      });
    }
  }

  function _handleShowContacts($event) {
    vmDataService.getContacts(vm.product.productId)
      .then((contacts) => {
        vm.product.contacts = contacts.data.result;
        _showViewContactsDialog($event, {
          vendor: vm.vendor,
          product: vm.product,
        });
      });
  }

  function _handlePerformRiskAssessment($event) {
    orgDataService.getUserPreference('DoNotShowRiskConfirm').then((response) => {
      const pref = response.data;
      if (pref === 'true') {
        _handleBeginRiskAssessment($event);
      } else {
        _showConfirmBeginRiskAssessmentDialog($event, {
          vendor: vm.vendor,
          product: vm.product,
        });
      }
    });
  }

  function _handlePerformControlsReview($event) {
    loaderService.showViewLoader = true;
    vmDataService.getProductRiskControlReviewTask(vm.product.productId, true, false)
      .then((response) => {
        const controlsReviewTask = response.data.result;

        vm.currentControlsReviewTask = controlsReviewTask;
        /** Already has a task in process */
        if (vm.currentControlsReviewTask && vm.currentControlsReviewTask.length > 0) {
          loaderService.showViewLoader = false;
          return _showConfirmControlsReviewDialog($event, {
            vendor: vm.vendor,
            product: vm.product,
            currentControlsReviewTask: vm.currentControlsReviewTask[0],
          });
        }
        /** No task started yet */
        vmDataService.getControlsForProductReview(vm.product.productId)
          .then((getControlsResponse) => {
            loaderService.showViewLoader = false;
            const product = getControlsResponse.data.product;

            angular.extend(vm.product, product);
            return _showSelectRiskControlsForReviewDialog($event, {
              riskControlReviewTaskId: -1,
              product: vm.product,
              vendor: vm.vendor,
            });
          });
      });
  }

  function _handleBeginRiskAssessment($event) {
    loaderService.showViewLoader = true;
    vmDataService.getRiskCategories().then((riskCategoriesResponse) => {
      vmDataService.getAssessmentQuestions(vm.product.productId).then((assessmentAnswerResponse) => {
        const riskCategories = riskCategoriesResponse.data.result;
        const assessmentAnswers = assessmentAnswerResponse.data.result;

        angular.forEach(riskCategories, (riskCategory) => {
          angular.forEach(assessmentAnswers, (assessmentAnswer) => {
            if (riskCategory.riskCategoryId === assessmentAnswer.riskCategoryId) {
              riskCategory.selectedScoreValue = assessmentAnswer.riskCategoryScore;
              riskCategory.note = assessmentAnswer.note;
            }
          });
        });

        showPerformRiskAssessmentDialog($event, {
          vendor: vm.vendor,
          product: vm.product,
          riskCategories,
          assessmentAnswers,
        });
        loaderService.showViewLoader = false;
      });
    });
  }

  function showPerformRiskAssessmentDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.performRiskAssessmentDialog = ssDialogService.alert(
      performRiskAssessmentDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.performRiskAssessmentDialog);
  }

  function _handleShowGraphView() {
    vm.productViewType = 'graph';
  }

  function _handleShowListView() {
    vm.productViewType = 'list';
  }

  function _handleDeleteProduct($event) {
    _showConfirmDeleteProductDialog($event);
  }

  function _handleCancelDeleteProduct() {
    _closeDeleteProductDialog();
  }

  function _handleEditProduct($event) {
    if (vm.product.detailedDataIsLoaded) {
      return _showEditProductDialog($event, {
        masterVendorId: vm.vendor.masterVendorId,
        product: vm.product,
        vendor: vm.vendor,
      });
    }
    loaderService.showViewLoader = true;
    return _loadProductDetails($event).then(() => {
      loaderService.showViewLoader = false;
      return _showEditProductDialog($event, {
        masterVendorId: vm.vendor.masterVendorId,
        product: vm.product,
        vendor: vm.vendor,
      });
    });
  }

  function _handleRunDetailReport() {
    loaderService.showViewLoader = true;
    return vmDataService.getProductDetailReport()
      .then((reportData) => {
        const reportId = reportData.data.reportId;
        const parameters = [];
        parameters.push({
          ParameterName: 'ProductID',
          ParameterValue: vm.product.productId.toString(),
        });
        reportsDataService.generateAppReport(1, reportId, 'PDF', parameters, false)
          .then((response) => {
            reportsDataService.download(response);
            loaderService.showViewLoader = false;
            $scope.$broadcast('runVendorManagementReport', reportData);
          });
      });
  }

  function _handleConfirmDeleteProduct(product) {
    loaderService.showViewLoader = true;
    return _deleteProduct(product)
      .then(() => {
        alerts.success(`The Product "${product.name}" has successfully been deleted.`);
        vmSharedModelService.resetProductCache(product.vendorId);
        $rootScope.$broadcast('refreshNotifications');
        $rootScope.$broadcast('refreshVMVendor', { vendorId: vm.vendor.vendorId });
        _closeDeleteProductDialog();
      }).catch(() => {
        alerts.error('An error occurred deleting the product.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }


  /** *************************************************************
   * Private Functions
   */

  function _activate() {
    vm.canExpand = true;
    _initTooltipsText();
    vm.appIsLoaded = true;
  }

  function _initEventListeners() {
    $scope.$on('refreshVMDocuments', (event, opt) => {
      if ((opt.documentId === vm.product.documentId1) || (opt.documentId === vm.product.documentId2)
        || (opt.documentId === vm.product.documentId3)) {
        _loadProductDetails(event);
      }
    });
  }

  function _initTooltipsText() {
    const {
      name, isConcentrationRisk, isCloudBased, isForeignBased
    } = vm.product;
    vm.product.concentrationRiskText = `${name} is ${isConcentrationRisk ? '' : 'not '}a concentration risk`;
    vm.product.cloudBasedText = `${name} is ${isCloudBased ? '' : 'not '}cloud based`;
    vm.product.foreignBasedText = `${name} is ${isForeignBased ? '' : 'not '}foreign based`;
  }

  function _deleteProduct(product) {
    return vmSharedModelService.deleteProduct(product.productId)
      .then(() => {
        vm.deleteCallback(product);
      });
  }

  function _loadProductDetails($event) {
    return vmDataService.getProductDetails(vm.product.productId)
      .then((response) => {
        const productDetails = response.data;

        angular.extend(vm.product, productDetails);
        if (vm.product.graphedRiskAssessments && vm.product.graphedRiskAssessments.length > 0) {
          _renderInherentRiskGraph($event);
        }

        if (vm.product.nonGraphedRiskAssessments && vm.product.nonGraphedRiskAssessments.length > 0) {
          R.forEach((assessment) => {
            if (assessment.riskCategoryId === 7) {
              vm.product.concentrationRiskText = `${vm.product.name} is ${(assessment.score > 0) ? '' : 'not '}a
              concentration risk`;
            } else if (assessment.riskCategoryId === 8) {
              vm.product.cloudBasedText = `${vm.product.name} is ${(assessment.score > 0) ? '' : 'not '}cloud based`;
            } else if (assessment.riskCategoryId === 9) {
              vm.product.foreignBasedText = `${vm.product.name} is ${(assessment.score > 0) ? '' : 'not '}foreign
              based`;
            }
          }, vm.product.nonGraphedRiskAssessments);
        }
        vm.product.detailedDataIsLoaded = true;
      });
  }

  function _renderInherentRiskGraph() {
    const categories = [];
    const data = [];
    const $elGraphContainer = angular.element(
      `.vm-risk-assessment-graph-container[product-id="${vm.product.productId}"]`
    );
    // const $elGraphContainer = $event.currentTarget.parentElement.nextElementSibling
    //   .querySelectorAll(`[product-id="${vm.product.productId}"]`);

    R.forEach(
      (assessment) => {
        let color;

        categories.push(assessment.name);
        if (assessment.score > 4) {
          color = brandColors.bankersLoveRed.$100;
        } else if (assessment.score > 3) {
          color = brandColors.bankersLoveRed.$75;
        } else if (assessment.score > 2) {
          color = brandColors.navantaCoral.$100;
        } else if (assessment.score > 1) {
          color = brandColors.navantaCoral.$55;
        } else {
          color = brandColors.navantaCoral.$25;
        }
        data.push({
          y: assessment.score,
          color,
        });
      },
      vm.product.graphedRiskAssessments
    );

    if (!$elGraphContainer[0]) {
      return true; // Don't attempt to render the chart if the target element isn't found
    }

    Highcharts.chart($elGraphContainer[0],
      {
        chart: {
          type: 'column',
          height: 210,
          backgroundColor: brandColors.navantaCharcoal.$5,
        },
        title: null,
        tooltip: { enabled: false },
        xAxis: {
          categories,
          labels: {
            style: {
              fontSize: '15px',
              fontWeight: 'bold',
              color: brandColors.navantaCharcoal.$100,
              fontFamily: 'Verlag Black',
            },
          },
          title: { text: null },
        },
        yAxis: {
          min: 0,
          max: 5,
          labels: { overflow: 'justify' },
          tickInterval: 1,
          title: { enabled: false },
        },
        legend: { enabled: false },
        plotOptions: { series: { states: { hover: false } } },
        credits: { enabled: false },
        series: [{ name: 'Risk Score', data }],
      });
  }


  /** *************************************************************
   * Private Functions
   * DIALOGS
   */

  function _showViewContactsDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.viewContactsDialog = ssDialogService.alert(
      viewContactsDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.viewContactsDialog);
  }

  function _showEditProductDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editProductDialog = ssDialogService.alert(
      editProductDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editProductDialog);
  }

  function _showConfirmBeginRiskAssessmentDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.confirmBeginRiskAssessmentDialog = ssDialogService.alert(
      confirmBeginRiskAssessmentDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmBeginRiskAssessmentDialog);
  }

  function _showSelectRiskControlsForReviewDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog = ssDialogService.alert(
      selectRiskControlsForReviewDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.selectRiskControlsForReviewDialog);
  }

  function _showConfirmControlsReviewDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.confirmControlsReviewDialog = ssDialogService.alert(
      confirmControlsReviewDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmControlsReviewDialog);
  }

  function _closeDeleteProductDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog);
  }

  function _showConfirmDeleteProductDialog($event) {
    ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Product?',
        message: `Are you sure you want to delete the product "${vm.product.name}"?`,
        handleYesClick() {
          _handleConfirmDeleteProduct(vm.product);
        },
        handleNoClick: _handleCancelDeleteProduct,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog);
  }
}

ProductController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'brandColors',
  'confirmDialog',
  'copy',
  'loaderService',
  'ssDialogService',
  'userService',
  'orgDataService',
  'vmDataService',
  'vmSharedModelService',
  'reportsDataService',
  'viewContactsDialog',
  'editProductDialog',
  'confirmBeginRiskAssessmentDialog',
  'confirmControlsReviewDialog',
  'selectRiskControlsForReviewDialog',
  'performRiskAssessmentDialog'
];
